import {HttpResponse} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {Principal} from '@core/index';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {DialogService} from '@shared/confirm-dialog/dialog.service';
import {DOMAIN_IMAGE_URL} from '@shared/constants/domain';
import {IProduct} from '@entities/san-pham/san-pham.model';
import {ExampleStampService} from '@entities/example-stamp/example-stamp.service';

@Component({
  selector: 'app-example-stamp',
  templateUrl: './example-stamp.component.html',
})
export class ExampleStampComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'id',
    'exampleStampName',
    'description',
    'createdDate',
    'exampleStampImage',
    'action',
  ];
  dataSource: MatTableDataSource<IProduct> = new MatTableDataSource<IProduct>(
    [],
  );
  pageSizeOptions: number[] = PAGE_SIZE_OPTIONS;
  ELEMENT_DATA: IProduct[] = [];
  links: any;
  totalItems = 0;
  queryCount = 0;
  itemsPerPage = ITEMS_PER_PAGE;
  page = 1;
  currentSearch = '';
  eventSubscriber?: Subscription;
  noData = false;
  isLoading = true;
  readonly DOMAIN_IMAGE_URL = DOMAIN_IMAGE_URL;
  constructor(
    private titleService: Title,
    private alertService: JhiAlertService,
    private principal: Principal,
    private parseLinks: JhiParseLinks,
    private eventManager: JhiEventManager,
    private activatedRoute: ActivatedRoute,
    private stampService: ExampleStampService,
    private confirmService: DialogService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.exampleStamp.exampleStamp.list'),
    );
    this.loadAll();
    this.eventSubscriber = this.eventManager.subscribe(
      'stampListModification',
      () => this.loadAll(),
    );
  }

  ngOnDestroy() {
    if (this.eventSubscriber) {
      this.eventManager.destroy(this.eventSubscriber);
    }
  }
  search(query: string) {
    this.page = 1;
    this.currentSearch = query;
    this.loadAll();
  }
  loadAll() {
    this.isLoading = true;
    this.stampService
      .query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['createdDate,desc'],
      })
      .subscribe(
        (res: HttpResponse<IProduct[]>) => {
          this.isLoading = false;
          this.totalItems = Number(res.headers.get('X-Total-Count')) || 0;
          this.queryCount = this.totalItems;
          this.ELEMENT_DATA = res.body || [];
          this.dataSource = new MatTableDataSource<IProduct>(this.ELEMENT_DATA);
          this.noData = !this.ELEMENT_DATA || this.ELEMENT_DATA.length === 0;
        },
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          this.alertService.error(res?.body?.error, res?.body?.message, null);
        },
      );
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }
}
